<template>
	<div>
		{{ parsed }}
	</div>
</template>

<script>
export default {
	name: 'ArgArithmetic',
	props: {
		value: Object,
	},
	computed: {
		parsed() {
			if (this.value.data === 0) {
				return 'Infinity'
			}
			if (this.value.data === 1) {
				return '-Infinity'
			}
			if (this.value.data === 2) {
				return '-0'
			}
			return this.value
		},
	},
}
</script>
